import React from 'react';
import { useTranslations, useLocale } from 'next-intl';
import FormCompact from '@components/molecules/form/formCompact';
import track from '@helper/tracking';
import newsletterGerman from './data-compact/00-newsletter';
import newsletterEnglish from './data-compact/01-newsletter-en';

const newsletterData = {
  de: newsletterGerman,
  en: newsletterEnglish
};

const NewsletterForm = () => {
  const t = useTranslations();
  const locale = useLocale();
  return (
    <FormCompact
      {...newsletterData[locale]}
      successMessage={t('form.newsletterSuccess')}
      onSubmit={() => {
        track(['trackEvent', 'Newsletter', 'Signup', locale]);
      }}
    />
  );
};

export default NewsletterForm;
